import React, {useEffect} from "react";
import { useAppContext } from "../context";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import SignUp from "../Pages/SignUp/SignUp.jsx";
import Login from "../Pages/Login/Login.jsx";
import Perfil from "../Pages/Perfil/Perfil.jsx";
import ListadoAlumnos from "../Pages/ListadoAlumnos/ListadoAlumnos.jsx";
import Actividades from "../Pages/Actividades/Actividades.jsx";
import ActivityPage from "../Pages/Actividades/ActivityPage.jsx";
import AgregarActividad from "../Pages/Actividades/AgregarActividad.jsx";
import EditarActividad from "../Pages/Actividades/EditarActividad.jsx";
import HomeAdmin from "../Pages/Admin/HomeAdmin.jsx";
import HomeAlumno from "../Pages/Alumno/HomeAlumno.jsx";
import Fechas from "../Pages/Fechas/Fechas.jsx";
import VerFechas from "../Pages/Fechas/VerFechas.jsx";
import MainRoutes from "./MainRoutes.jsx";
import AdminRoutes from "./AdminRoutes.jsx";
import AdminProfeRoutes from "./AdminProfeRoutes.jsx";
import AuthRoutes from "./AuthRoutes.jsx";
import AlumnoRoutes from "./AlumnoRoutes.jsx";
import Qr from "../Pages/Alumno/Qr/Qr.jsx"
import Home from "../Pages/Home/Home.jsx";
import { getUserByEmail } from "../utils";
import { app } from "../credenciales.js";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import QrScanner from '../Pages/Admin/QrScanner/QrScanner.jsx';
import QrPage from "../Pages/Admin/QrScanner/QrPage.jsx";
import AltaUsuario from "../Pages/Usuario/AltaUsuario.jsx";
import ListaProfesores from "../Pages/Profesores/ListaProfesores.jsx";
import ProfesorPage from "../Pages/Profesores/ProfesorPage.jsx";
import PasswordReset from "../Pages/PasswordReset/PasswordReset.jsx";

const auth = getAuth(app);

export const AppRoutes = () => {
  const {user, setUser} = useAppContext();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const data = await getUserByEmail(user.email);
          if (data) {
            setUser(data[0]);
            sessionStorage.setItem("userLoggedIn", true);
            sessionStorage.setItem("userRole", data[0].role);
            sessionStorage.setItem("correo", data[0].email);
          } else {
            console.log("User not found in Firestore");
            clearUserData();
          }
        } catch (error) {
          console.log(error);
          clearUserData();
        }
      } else {
        clearUserData();
      }

    });
    return () => unsubscribe();
  }, [setUser]);

  const clearUserData = () => {
    setUser(null);
    sessionStorage.removeItem("userLoggedIn");
    sessionStorage.removeItem("userRole");
    sessionStorage.removeItem("correo");
  };
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainRoutes />}>
          <Route path="perfil" element={<Perfil />} />
        </Route>
        <Route element={<AuthRoutes />}>
          <Route path="" element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="signUp" element={<SignUp />} />
          <Route path="recuperarContraseña" element={<PasswordReset />} />
        </Route>
        <Route element={<AdminRoutes />}>
          <Route path="alumnos" element={<ListadoAlumnos />} />
          <Route path="actividades" element={<Actividades />} />
          <Route path="activityPage/:idActividad" element={<ActivityPage />} />
          <Route path="agregarActividad" element={<AgregarActividad />} />
          <Route path="editarActividad/:idActividad" element={<EditarActividad />} />
          <Route path="homeAdmin" element={<HomeAdmin />} />
          <Route path="fechas/:idActividad" element={<Fechas />} />
          <Route path=":idActividad/:fecha" element={<VerFechas />} />
          <Route path="altaUsuario" element={<AltaUsuario />} />
          <Route path="listaProfesores" element={<ListaProfesores />} />
          <Route path="profesorPage/:idProfesor" element={<ProfesorPage />} />
        </Route>
        <Route element={<AdminProfeRoutes />}>
          <Route path="qrScanner" element={<QrScanner />} />
          <Route path="qrPage/:idActividad" element={<QrPage />} /> 
        </Route>
        <Route element={<AlumnoRoutes />}>
          <Route path="homeAlumno" element={<HomeAlumno />} />
          <Route path="qr" element={<Qr />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );

};